import React, { Fragment } from "react";
import {
  Facebook as FacebookIcon,
  YouTube as YouTubeIcon,
  Instagram as InstagramIcon,
  LocationOn as LocationOnIcon,
} from "@mui/icons-material";
import { Link } from "gatsby";

const MainFooter = ({
  address = "1220 River Bend Dr. Suite 250, Office 212 Dallas, Texas 75247",
  // phoneNumber = "800-971-4060",
}) => {
  const links = [
    {
      name: "Home",
      path: "/",
    },
    {
      name: "Apply",
      path: "/apply/",
    },
    {
      name: "How it works",
      path: "/how-it-works/",
    },
    {
      name: "About us",
      path: "/about-us/",
    },
    {
      name: "Privacy Policy / Terms of service",
      path: "/privacy-policy/",
    },
    // {
    //   name: "Resources",
    //   path: "/resources/",
    // },
    // {
    //   name: "Client Stories",
    //   path: "/client-stories/",
    // },
    // {
    //   name: "Blog",
    //   path: "/blog/",
    // },
  ];

  return (
    <Fragment>
      <footer className="bg-custom-primary py-16">
        <div className="container">
          <div className="grid grid-cols-1 lg:grid-cols-[40%_30%_30%] gap-6">
            <div>
              <img
                src="/images/favicon.webp"
                width={60}
                height={60}
                alt="Logo"
              />
              <div className="flex items-center mt-6">
                <a
                  className="bg-white me-4 w-[32px] h-[32px] rounded-full flex justify-center items-center"
                  href="https://web.facebook.com/debtredemptioninc?_rdc=1&_rdr"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Facebook Btn"
                >
                  <FacebookIcon className="text-custom-primary !text-base !font-normal" />
                </a>
                <a
                  className="bg-white me-4 w-[32px] h-[32px] rounded-full flex justify-center items-center"
                  href="https://www.youtube.com/c/DebtRedemptionTexasDebtRelief"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Youtube Btn"
                >
                  <YouTubeIcon className="text-custom-primary !text-base !font-normal" />
                </a>
                <a
                  className="bg-white w-[32px] h-[32px] rounded-full flex justify-center items-center"
                  href="https://www.instagram.com/debtredemption/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram Btn"
                >
                  <InstagramIcon className="text-custom-primary !text-base !font-normal" />
                </a>
              </div>
              <p className="text-xl font-normal text-white mb-4 mt-8">
                Consultations with a Texas Debt Specialist are free of charge
                and have no obligation.
              </p>
            </div>
            <div>
              <p className="text-2xl font-normal text-white mb-6">
                Quick Links
              </p>
              <ul>
                {links.map((link, index) => (
                  <li className="mb-6" key={index}>
                    <Link
                      className="text-lg font-light text-white capitalize transition-all duration-200 opacity-100 hover:opacity-60"
                      to={link.path}
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            {/* <div>
              <p className="text-2xl font-normal text-white mb-6">
                Useful Links
              </p>
              <ul>
                {links.map((link, index) => (
                  <li className="mb-6" key={index}>
                    <Link
                      className="text-lg font-light text-white capitalize transition-all duration-200 opacity-100 hover:opacity-60"
                      to={link.path}
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-2xl font-normal text-white mb-6">Support</p>
              <ul>
                {links.slice(0, 3).map((link, index) => (
                  <li className="mb-6" key={index}>
                    <Link
                      className="text-lg font-light text-white capitalize transition-all duration-200 opacity-100 hover:opacity-60"
                      to={link.path}
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div> */}
            <div>
              <p className="text-xl font-bold text-white mb-2">Local Office</p>
              <p className="text-md font-medium text-white flex items-center">
                <LocationOnIcon className="me-2" /> 40 NE Interstate 410 Loop,
                Suite 565 San Antonio, Texas 78216
              </p>
              <p className="text-xl font-bold text-white mt-12 mb-2">
                Corporate Office
              </p>

              <p className="text-md font-medium text-white flex items-center text-balance w-auto">
                <LocationOnIcon className="me-2" /> {address}
              </p>
              <p className="text-md font-normal text-white w-[22rem] mt-8 ms-2 text-balance">
                Please Call For Additional Texas Branch Locations
              </p>
            </div>
          </div>
          <div className="mt-20 text-white font-normal">
            <h3 className="text-xl mb-3">
              © Debt Redemption Texas Debt Relief {new Date().getFullYear()}
            </h3>
            <p className="text-xs text-justify">
              *Debt Redemption’s performance (settlement) fees are 15% versus up
              to 25% charged by many out-of-state competitors. Debt Redemption
              is not a lender but offers an affiliate platform to receive loan
              offers from multiple lenders. Clients who are able to remain with
              the program and resolve all their debts generally experience an
              approximate 45% reduction of their enrolled balance before our
              performance fee of 15%, a $9.95 monthly bank fee, and any optional
              third-party fees. Individual results may vary based on the ability
              to save sufficient funds, the ability to complete the program, and
              the creditors enrolled. Statements made are examples of past
              performance and are not intended to be a guarantee that your debt
              balances will be lowered by a specific amount or percentage or
              that you will be debt-free within a specific time period.
              Settlement fees are not charged until a debt is reduced and
              payment has been made to a creditor. The use of debt settlement
              services will likely adversely affect your creditworthiness, may
              result in you being subject to collections or being sued by
              creditors or collectors, and may increase the outstanding balances
              of your enrolled accounts due to the accrual of fees and interest.
              We do not assume consumer debt, make monthly payments to
              creditors, or provide tax, bankruptcy, accounting, or legal
              advice. We do not provide credit repair services. For answers to
              common questions, please visit our FAQs page. Optional separate
              legal services may be offered by attorneys or legal plan providers
              and all associated fees are paid directly to the providers. Please
              contact a tax professional to discuss any possible tax
              consequences of paying less than the full balance. Programs are
              only available in Texas. Logos used are the property of their
              respective owners.
            </p>
          </div>
        </div>
      </footer>
    </Fragment>
  );
};

export default MainFooter;
